(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTime', {
    templateUrl: 'app/facilityKarcherDetails/operatingTime/operatingTime.html',
    controller: operatingTime,
    bindings: {
      operatingTimeList: '<',
      deviceKey: '<',
      activation: '&',
      refreshData: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTime(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    workingSchedulesActions,
    layoutActions,
    $stateParams,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (changes.operatingTimeList && changes.operatingTimeList.currentValue) {
        vm.operatingTimeList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    // Temporary, delete when testing is done
    vm.displayDepelopersOnly = helperService.getDevelopAccess();

    vm.updateOperationTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTime/actuateOperationTime.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };

    vm.getSiteWorkingSchedules = function () {
      layoutActions.showLoader();
      var path = '?deviceKey=' + vm.deviceKey;
      workingSchedulesActions
        .propagateWorkingSchedules($stateParams.id, path)
        .then(function () {
          vm.refreshData();
          layoutActions.hideLoader();
        });
    };
  }
})();
